/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { ResourceCollection } from 'store/collections/types';
import { useIntl } from 'react-intl';
import { Chip } from '@hqo/react-components-library/dist/atoms/chip';

interface CollectionsComponentProps {
  collections: Array<ResourceCollection & { originalUuids?: string[] }>;
  selectedCollections: string[];
  onCollectionChipClickHandler: (value: string) => void;
}

export const CollectionsComponent = ({
  collections,
  selectedCollections,
  onCollectionChipClickHandler,
}: CollectionsComponentProps): JSX.Element => {
  const intl = useIntl();

  const getCollectionName = (collection: ResourceCollection): string => {
    const { locale } = intl;
    if (collection.translations?.[locale]?.name) {
      return collection.translations[locale].name;
    }
    if (collection.translations?.en?.name) {
      return collection.translations.en.name;
    }
    return collection.name || 'Unnamed Collection';
  };

  return (
    <>
      {collections?.map(collection => {
        const uuidsToCheck = collection.originalUuids || [collection.uuid];
        const isActive = uuidsToCheck.some(uuid => selectedCollections.includes(uuid));

        return (
          <Chip
            key={collection.uuid}
            label={getCollectionName(collection)}
            value={collection.uuid}
            isActive={isActive}
            onChipClick={onCollectionChipClickHandler}
            className="collection-chip"
            data-test={`collection-filter-chip-${collection.uuid}`}
            hoverEnabled={false}
          />
        );
      })}
    </>
  );
};
